/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
import "lit";
function getIconScale(componentScale) {
  return componentScale === "l" ? "m" : "s";
}
function isHidden(el) {
  return el.hidden !== false || el.itemHidden;
}
async function componentFocusable(component) {
  await component.componentOnReady();
  await component.updateComplete;
}
export {
  componentFocusable as c,
  getIconScale as g,
  isHidden as i
};
